import React, {Component} from 'react';
import Snackbar from "@material-ui/core/es/Snackbar";
import {connect} from "react-redux";
import bindActionCreators from "redux/es/bindActionCreators";
import {closeNotification} from "./NotificationsActions";
import {MdClose} from 'react-icons/md';
import IconButton from "@material-ui/core/es/IconButton";

class Notifications extends Component {

    render() {
        const {notifications, closeNotification} = this.props;
        return(
            <Snackbar
                open={!!notifications.text}
                onClose={closeNotification}
                autoHideDuration={10000}
                SnackbarContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{notifications.text}</span>}
                action={[
                   // <Button key="undo" color="secondary" size="small" onClick={this.handleClose}>
                   //     UNDO
                //    </Button>,
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={closeNotification}
                    >
                        <MdClose />
                    </IconButton>,
                ]}
            />
        )
    }

}

function mapStateToProps({notifications}) {
    return {notifications}
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeNotification
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.js